@if(service.viewDroplistItems.length){
<div class='admissions-overview-views-part'>
	@if(service.selectedViewItem(); as selectedViewItem){
	<droplist class="views-droplist" [items]='service.viewDroplistItems' [selectedItem]='selectedViewItem'
		(selectionChange)='service.onViewDroplistChange($event)' [filterable]='false' [navigation]='true'
		sortBy='customSort' style='display:inline-block'> </droplist>
	@switch (selectedViewItem.uniqueId) {
	@case (service.viewId.Overview) {
	<admissions-overview-view-part></admissions-overview-view-part>
	}
	}
	}
</div>
}